import {Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {PrintService} from '../../services/print.service';
import {CommonService} from '../../services/common.service';

@Component({
  selector: 'app-print-container',
  templateUrl: './print-container.component.html',
  styleUrls: ['./print-container.component.css']
})
export class PrintContainerComponent implements OnDestroy {
  private readonly onDestroy = new Subject<void>();
  @ViewChild('printContainer', {static: true, read: ViewContainerRef})
  printContainer: ViewContainerRef;
  currentComponentInstance: ComponentRef<any>;
  onClose: () => void;

  constructor(
    printService: PrintService,
    commonService: CommonService,
  ) {
    // listen for print open with component
    printService.onPrintOpen
      .pipe(takeUntil(this.onDestroy))
      .subscribe(({component, data, onClose}) => {
        // render component
        this.onClose = onClose;
        this.renderComponent({component, data});
      });

    // listen for print start
    printService.onPrintStart
      .pipe(takeUntil(this.onDestroy))
      .subscribe(async (name) => {
        // wait for few seconds to render all UI part
        await commonService.wait(1000);

        const currentTitle = document.title;
        if (name?.trim()) {
          document.title = name;
        }

        // open print view
        await this.print();

        document.title = currentTitle;

        // clear
        this.clear();

        this.onClose();
        this.onClose = null;
      });

    // listen for print stop
    printService.onPrintStop
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.clear();

        this.onClose();
        this.onClose = null;
      })
  }

  /**
   * Opens print window and waits until it is open.
   * Written this method because earlier window.open() was waiting until it finishes, but now it's not waiting.
   */
  print() {
    return new Promise((resolve) => {
      // listen for print dialog close event
      window.onafterprint = resolve;

      // open print dialog
      window.print();
    })
  }

  renderComponent({component, data}) {
    this.clear();
    this.currentComponentInstance = this.printContainer.createComponent(component);
    this.currentComponentInstance.instance['printData'] = data;
  }

  clear() {
    this.currentComponentInstance?.destroy();
    this.currentComponentInstance = null;
    this.printContainer.clear();
  }

  ngOnDestroy() {
    this.onDestroy.next();
  }
}
